import { render, staticRenderFns } from "./riskControl.vue?vue&type=template&id=4814dff2&scoped=true&"
import script from "./riskControl.vue?vue&type=script&lang=js&"
export * from "./riskControl.vue?vue&type=script&lang=js&"
import style0 from "./riskControl.vue?vue&type=style&index=0&id=4814dff2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814dff2",
  null
  
)

export default component.exports